module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "mobileNavigationTransition"
    }
  }, [(_vm.mobileMenuOpen) ? _c('div', {
    class: [_vm.block]
  }, [_c('div', {
    class: [_vm.block + '-navigation']
  }, [_c('div', {
    class: [_vm.block + '-links']
  }, _vm._l((_vm.mobileLinks.highlight), function(link) {
    return _c('div', [(link.subheadings == null) ? _c('div', {
      class: [_vm.block + '-link m-highlight', {
        'm-active': link.path === _vm.pagePath
      }],
      on: {
        "click": function($event) {
          _vm.goTo(link.path)
        }
      }
    }, [_vm._v("\n                " + _vm._s(link.text) + "\n            ")]) : _c('div', [_c('expandable-block', {
      class: [_vm.block + '-link m-highlight m-noHover'],
      attrs: {
        "index": 1,
        "active": _vm.active,
        "height": 36,
        "icon": "24px_chevronDown",
        "data": {
          header: 'Products',
          blockModifiers: ['navigation', 'floatIconRight'],
          components: [{
              type: 'text-link',
              data: {
                linkText: 'In-content commerce',
                route: 'incontent',
                blockModifiers: ['noUnderline']
              }
            },
            {
              type: 'text-link',
              data: {
                linkText: 'Virtual marketplace',
                route: 'shop',
                blockModifiers: ['noUnderline']
              }
            },
            {
              type: 'text-link',
              data: {
                linkText: 'Bag & checkout',
                route: 'checkout',
                blockModifiers: ['noUnderline']
              }
            }
          ],
        }
      },
      on: {
        "activeExpandableChanged": _vm.toggleExpandable
      }
    }), _vm._v(" "), _c('expandable-block', {
      class: [_vm.block + '-link m-highlight m-noHover'],
      attrs: {
        "index": 2,
        "active": _vm.active,
        "height": 36,
        "icon": "24px_chevronDown",
        "data": {
          header: 'Tools',
          blockModifiers: ['navigation', 'floatIconRight'],
          components: [{
              type: 'text-link',
              data: {
                linkText: 'Commerce Manager',
                route: 'commercemanager',
                blockModifiers: ['noUnderline']
              }
            },
            {
              type: 'text-link',
              data: {
                linkText: 'Spotin Portal',
                route: 'portal',
                blockModifiers: ['noUnderline']
              }
            } ],
        }
      },
      on: {
        "activeExpandableChanged": _vm.toggleExpandable
      }
    })], 1)])
  })), _vm._v(" "), _c('div', {
    class: [_vm.block + '-links']
  }, [_vm._l((_vm.mobileLinks.other), function(link) {
    return _c('div', {
      class: [_vm.block + '-link', {
        'm-active': link.path === _vm.pagePath
      }],
      on: {
        "click": function($event) {
          _vm.goTo(link.path)
        }
      }
    }, [_vm._v("\n            " + _vm._s(link.text) + "\n          ")])
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-social']
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/company/spotinab",
      "target": "_blank"
    }
  }, [_c('ImageBlock', {
    class: [_vm.block + '-socialLink'],
    attrs: {
      "data": {
        src: 'Linkedin_20x20.svg',
        alt: 'Linkedin'
      }
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/spotinofficial/",
      "target": "_blank"
    }
  }, [_c('ImageBlock', {
    class: [_vm.block + '-socialLink'],
    attrs: {
      "data": {
        src: 'Instagram_20x20.svg',
        alt: 'Instagram'
      }
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/spotinab",
      "target": "_blank"
    }
  }, [_c('ImageBlock', {
    class: [_vm.block + '-socialLink'],
    attrs: {
      "data": {
        src: 'Facebook_20x20.svg',
        alt: 'Facebook'
      }
    }
  })], 1)])], 2)]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-getStarted']
  }, [_c('ButtonBlock', {
    attrs: {
      "blockModifiers": ['largeFont', 'hoverHightlight'],
      "text": 'Get started'
    },
    nativeOn: {
      "click": function($event) {
        _vm.openGetStartedMenu($event)
      }
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-991c6c4c","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/templates/Navigation.vue
// module id = 544
// module chunks = 0